import React from 'react';
import { useSelector } from 'react-redux';

import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import { enUS, esES, frFR, heIL, itIT } from '@mui/x-date-pickers/locales';

import { localeSelector } from '@/domain/env';

type SupportedLocale = 'en' | 'es' | 'fr' | 'he' | 'it';

const LOCALE_TEXT_BY_CODE: Record<
  SupportedLocale,
  typeof enUS.components.MuiLocalizationProvider.defaultProps.localeText
> = {
  en: enUS.components.MuiLocalizationProvider.defaultProps.localeText,
  es: esES.components.MuiLocalizationProvider.defaultProps.localeText,
  fr: frFR.components.MuiLocalizationProvider.defaultProps.localeText,
  he: heIL.components.MuiLocalizationProvider.defaultProps.localeText,
  it: itIT.components.MuiLocalizationProvider.defaultProps.localeText,
};

const isSupportedLocale = (value: unknown): value is SupportedLocale =>
  typeof value === 'string' && Object.prototype.hasOwnProperty.call(LOCALE_TEXT_BY_CODE, value);

type Props = { children: React.ReactNode };

const LocalizedDatePickerProvider: React.FC<Props> = ({ children }) => {
  const raw = useSelector(localeSelector);
  const locale: SupportedLocale = isSupportedLocale(raw) ? raw : 'en';

  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      adapterLocale={locale}
      localeText={LOCALE_TEXT_BY_CODE[locale]}
    >
      {children}
    </LocalizationProvider>
  );
};

export default LocalizedDatePickerProvider;
